import React, { memo } from "react";
import type { IconProps } from "./_IconProps";

const Close = ({ size }: IconProps) => {
  return (
    <svg
      width={size || "14"}
      height={size || "14"}
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.705 2.115C0.315639 1.72564 0.315639 1.09436 0.705 0.705C1.09436 0.315639 1.72564 0.315639 2.115 0.705L7 5.59L11.885 0.705C12.2744 0.315639 12.9056 0.315639 13.295 0.705C13.6844 1.09436 13.6844 1.72564 13.295 2.115L8.41 7L13.295 11.885C13.6844 12.2744 13.6844 12.9056 13.295 13.295C12.9056 13.6844 12.2744 13.6844 11.885 13.295L7 8.41L2.115 13.295C1.72564 13.6844 1.09436 13.6844 0.705 13.295C0.315639 12.9056 0.315639 12.2744 0.705 11.885L5.59 7L0.705 2.115Z"
        fill="white"
      />
    </svg>
  );
};

export default memo(Close);
